import { render, staticRenderFns } from "./groupProduct.vue?vue&type=template&id=554fe05a&scoped=true"
import script from "./groupProduct.vue?vue&type=script&lang=js"
export * from "./groupProduct.vue?vue&type=script&lang=js"
import style0 from "./groupProduct.vue?vue&type=style&index=0&id=554fe05a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554fe05a",
  null
  
)

export default component.exports